const FALLBACK_GOOGLE_KEY = 'AIzaSyB_IzYR_v19OdxYu1FtoY_XCSs9N_wjMmY';

declare global {
  interface Window {
    google?: {
      maps?: {
        places?: {
          Autocomplete?: new (
            input: HTMLInputElement,
            options?: Record<string, unknown>,
          ) => {
            addListener: (eventName: string, callback: () => void) => { remove?: () => void } | void;
            getPlace: () => Record<string, unknown> | null | undefined;
          };
        };
      };
    };
  }
}

let googleMapsPlacesPromise: Promise<void> | null = null;

function resolveGoogleApiKey(): string {
  const envKey = (import.meta.env.VITE_GOOGLE_API_KEY ?? '').trim();
  return envKey || FALLBACK_GOOGLE_KEY;
}

export function loadGoogleMapsPlacesApi(): Promise<void> {
  if (window.google?.maps?.places?.Autocomplete) {
    return Promise.resolve();
  }
  if (googleMapsPlacesPromise) {
    return googleMapsPlacesPromise;
  }

  googleMapsPlacesPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector<HTMLScriptElement>('script[data-google-places-loader="true"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(), { once: true });
      existingScript.addEventListener('error', () => reject(new Error('Failed to load Google Places API.')), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.dataset.googlePlacesLoader = 'true';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${resolveGoogleApiKey()}&libraries=places`;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Google Places API.'));
    document.head.appendChild(script);
  }).catch(error => {
    googleMapsPlacesPromise = null;
    throw error;
  });

  return googleMapsPlacesPromise;
}
